import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ResultData } from 'src/app/_models/ResultData';
import { SubTopicService } from 'src/app/_services/subTopic.service';
import { SyllabusService } from 'src/app/_services/syllabus.service';
import { SubTopic } from './../../../_models/subTopic';
import { ContentService } from './../../../_services/content.service';

@Component({
  selector: 'app-subtopic-concept',
  templateUrl: './subtopic-concept.component.html',
  styleUrls: ['./subtopic-concept.component.css']
})
export class SubtopicConceptComponent implements OnInit {
  conceptList = []
  subTopic = new SubTopic()
  constructor(
    private contentService : ContentService,
    private activatedRoute:ActivatedRoute,
    private subTopicService:SubTopicService,
    private syllabusService:SyllabusService

  ) { }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe(
      params=>{
        this.subTopicService.getSubTopicById(+params['server_subtopic_id']).subscribe({
          next:(data:ResultData)=>{
            this.subTopic=data.rs.data
            this.contentService.getConcentSubTopicsIndex(+params['server_subtopic_id']).subscribe(
              xx=>{
                this.conceptList =xx

              }
            )
          }
        }

        )
      }
    )
  }

}
